export default "__VITE_ASSET__amilDgcs__"